import type { ProjectRepository } from '@/domain/project/ProjectRepository'
import type { ProjectMetadata } from '@/domain/project/types'

export type ProjectSummary = {
  project: ProjectMetadata
  /** Reviewed blocks / total blocks in the current version. 0–1. */
  progress: number
  totalBlocks: number
  reviewedBlocks: number
}

/**
 * Returns project summaries for the library route, sorted by
 * `updatedAt` desc. Progress is derived from the current version's
 * blockStates.
 */
export async function listProjects(
  repo: ProjectRepository,
): Promise<ProjectSummary[]> {
  const projects = await repo.listProjects()
  const summaries: ProjectSummary[] = []
  for (const project of projects) {
    const version = await repo.getVersion(project.currentVersionId)
    if (!version) {
      summaries.push({ project, progress: 0, totalBlocks: 0, reviewedBlocks: 0 })
      continue
    }
    const states = Object.values(version.blockStates)
    const total = states.length
    const reviewed = states.filter((s) => s.reviewState === 'reviewed').length
    summaries.push({
      project,
      progress: total === 0 ? 0 : reviewed / total,
      totalBlocks: total,
      reviewedBlocks: reviewed,
    })
  }
  return summaries
}
